import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ o("path", { d: "M12 23.198c-.257 0-.515-.01-.772-.029-2.954-.238-5.47-1.992-6.747-4.708-1.315-2.801-1.049-5.975.705-8.49l5.403-8.397a1.67 1.67 0 0 1 1.41-.772c.573 0 1.106.286 1.411.772l5.404 8.406c1.754 2.496 2.02 5.67.705 8.481-1.277 2.707-3.793 4.47-6.747 4.708-.248.02-.515.029-.772.029Zm0-20.966a.215.215 0 0 0-.2.114L6.387 10.76s-.01.02-.02.02c-1.467 2.096-1.696 4.736-.59 7.07 1.048 2.24 3.135 3.698 5.565 3.889a7.58 7.58 0 0 0 1.316 0c2.44-.2 4.517-1.649 5.575-3.888 1.096-2.335.876-4.975-.591-7.072L12.2 2.346a.223.223 0 0 0-.2-.114Z" }, null, -1), r = [
  n
];
function s(a, l) {
  return e(), t("svg", c, [...r]);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
